import { useMutation } from "@/api/utils/useQuery"
import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"
import { MutationResult } from "@/api/utils/types"
import { EnrolmentRetryResponse } from "@/api/backofficeRest/generated/model"

export class EnrolmentMutatorClass {
  retryEnrolment(): MutationResult<number, EnrolmentRetryResponse> {
    return useMutation({
      ...BackofficeRestMutations.enrolment.retry(),
      serializerFn: (enrolmentId: number) => enrolmentId,
    })
  }
}

export const EnrolmentMutator = new EnrolmentMutatorClass()
